import { render, staticRenderFns } from "./DataDetailComponent.vue?vue&type=template&id=0685daf3&scoped=true"
import script from "./DataDetailComponent.vue?vue&type=script&lang=js"
export * from "./DataDetailComponent.vue?vue&type=script&lang=js"
import style0 from "./DataDetailComponent.vue?vue&type=style&index=0&id=0685daf3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0685daf3",
  null
  
)

export default component.exports